import { usePostTripsByTripIdPublishMutation } from '../../store/backendApi';

interface UsePublishTripReturn {
  publish: () => Promise<void>;
  isPublishing: boolean;
  hasUnpublishedChanges: boolean;
}

/**
 * Hook to handle trip publishing.
 * Platform-agnostic: Can be used in React Native.
 *
 * @param tripId - The trip ID to publish
 * @param unpublishedChanges - Whether the trip has unpublished changes
 * @returns Publish function, loading state, and unpublished changes flag
 */
export const usePublishTrip = (
  tripId?: string,
  unpublishedChanges?: boolean,
): UsePublishTripReturn => {
  const [publishMutation, { isLoading: isPublishing }] = usePostTripsByTripIdPublishMutation();

  const publish = async () => {
    if (!tripId) return;
    await publishMutation(tripId);
  };

  return {
    publish,
    isPublishing,
    hasUnpublishedChanges: unpublishedChanges ?? false,
  };
};
